// extracted by mini-css-extract-plugin
export default {"header":"header_header__ci8U8","header__heading":"header_header__heading__MN+ho"};